import { useCallback, useState } from 'react';

const useBooleanInput = (initialValue = false) => {
  const [value, setValue] = useState(initialValue);

  const toggle = useCallback(
    nextValue => {
      if (typeof nextValue === 'boolean') {
        setValue(!!nextValue);
        return;
      }
      setValue(value => !value);
    },
    [value, setValue]
  );

  return [value, toggle];
};

export default useBooleanInput;
